const initialState = {
  loadingPinMaps: null,
  pinMaps: {},
  assets: {
    company: {
      data : {
        assetFields: {},
        assets: {},
        pagination: {
          count: 0,
          pageCount: 1,
          pageSize: 20,
          perPage: 20,
          nameFilter: null,
          sortField: null,
          sortDirection: "desc",
          filters: [],
          filterQueryString: "",
          filtersActive: false,
          displayPageIndex: 0,
        },
      },
      loadingCompanyAssets: false,
    },
    companyAssetImportLogs: {
      data : {
        logs: [],
        pagination: {
          count: 0,
          pageCount: 1,
          pageSize: 20,
          perPage: 20,
          nameFilter: null,
          sortField: null,
          sortDirection: "desc",
          filters: [],
          // filterQueryString: "",
          // filtersActive: false,
          displayPageIndex: 0,
        },
      },
      loadingCompanyAssetLogs: false,
    },
    companyAssetLogView: {
      data : {
        logViewData: [],
        pagination: {
          count: 0,
          pageCount: 1,
          pageSize: 20,
          perPage: 20,
          nameFilter: null,
          sortField: null,
          sortDirection: "desc",
          filters: [],
          // filterQueryString: "",
          // filtersActive: false,
          displayPageIndex: 0,
        },
      },
      loadingCompanyAssetLogView: null,
      initialiseLog: true,
    },
    site: {
      data : {
        assetFields: {},
        assets: {},
        assetId: null,
        overrideLocal: false,
        assetUid: null,
        pagination: {
          count: 0,
          pageCount: 1,
          pageSize: 20,
          perPage: 20,
          nameFilter: null,
          sortField: null,
          sortDirection: "desc",
          filters: [],
          displayPageIndex: 0,
        },
      },      
      loadingSiteAssets: false,
    },
    siteView: {
      data : {
        assetUid: null,
      },
      loadingSiteViewAsset: false,
    }
  },
  enterpriseAssociations: [],
  manageEnterpriseAssociations: {
    associated: {
      data: [],
      pagination: {
        count: 0,
        pageCount: 1,
        pageSize: 20,
        perPage: 20,
        nameFilter: null,
        sortField: null,
        sortDirection: "desc",
        filters: [],
        displayPageIndex: 0,
      },
      loadingAssociatedEnterprises: false,
    },
    unassociated: {
      data: [],
      pagination: {
        count: 0,
        pageCount: 1,
        pageSize: 20,
        perPage: 20,
        nameFilter: null,
        sortField: null,
        sortDirection: "desc",
        filters: [],
        displayPageIndex: 0,
      },
      loadingUnassociatedEnterprises: false,
    },
    deleted: {
      data: [],
      pagination: {
        count: 0,
        pageCount: 1,
        pageSize: 20,
        perPage: 20,
        nameFilter: null,
        sortField: null,
        sortDirection: "desc",
        filters: [],
        displayPageIndex: 0,
      },
      loadingDeletedEnterprises: false,
    },
  },
  createEnterpriseCompanySites: {
    data : {
      sudoSites: [],
      pagination: {
        count: 0,
        pageCount: 1,
      },
    },
    filterOptions: [],
    loadingCompanyFilterOptions: null,
    pageSize: 20,
    loadingCompanyCreateEnterpriseSites: null,
  },
  formData: {
    data: null,
    error: null,
  },
  companyFields: {
    data: null,
    error: null,
  },
  enterpriseFields: {
    data: null,
    error: null,
  },
  enterpriseGroups: {
    data: null,
    error: null,
    loading: false,
  },
  siteRef: null,
}

const serviceDeskReducer = (state = initialState, action) => {
  switch (action.type) {

    // ------------------------------------------------------------------------> BEGINNING

    // Add site - get data to populate form
    case "LOAD_FORM_DATA_START":
      return {
        ...state,
        formData: {
          ...state.formData,
          error: null,
        }
      };
    case "LOAD_FORM_DATA_SUCCESS":
      return {
        ...state,
        formData: {
          ...state.formData,
          data: action.response,
        }
      };
    case "LOAD_FORM_DATA_FAILED":
      return {
        ...state,
        formData: {
          ...state.formData,
          error: action.error,
        }
      };
    case "LOAD_FORM_DATA_RESET":
      return {
        ...state,
        formData: initialState.formData,
      };

    // Add site - get company custom fields
    case "LOAD_COMPANY_FIELDS_START":
      return {
        ...state,
        companyFields: {
          ...state.companyFields,
          error: null,
        }
      };
    case "LOAD_COMPANY_FIELDS_SUCCESS":
      return {
        ...state,
        companyFields: {
          ...state.companyFields,
          data: action.response,
        }
      };
    case "LOAD_COMPANY_FIELDS_FAILED":
      return {
        ...state,
        companyFields: {
          ...state.companyFields,
          error: action.error,
        }
      };
    case "LOAD_COMPANY_FIELDS_RESET":
      return {
        ...state,
        companyFields: initialState.companyFields,
      };
    
    // Add site - get enterprise custom fields
    case "LOAD_ENTERPRISE_FIELDS_START":
      return {
        ...state,
        enterpriseFields: {
          ...state.enterpriseFields,
          error: null,
        }
      };
    case "LOAD_ENTERPRISE_FIELDS_SUCCESS":
      return {
        ...state,
        enterpriseFields: {
          ...state.enterpriseFields,
          loading: false,
          data: action.response?.data[0],
        }
      };
    case "LOAD_ENTERPRISE_FIELDS_FAILED":
      return {
        ...state,
        enterpriseFields: {
          ...state.enterpriseFields,
          error: action.error,
        }
      };
    case "LOAD_ENTERPRISE_FIELDS_RESET":
      return {
        ...state,
        enterpriseFields: initialState.enterpriseFields,
      };
    
    // Add site - get enterprise groups
    case "LOAD_ENTERPRISE_GROUPS_START":
      return {
        ...state,
        enterpriseGroups: {
          ...state.enterpriseGroups,
          error: null,
          loading: true,
        }
      };
    case "LOAD_ENTERPRISE_GROUPS_SUCCESS":
      return {
        ...state,
        enterpriseGroups: {
          ...state.enterpriseGroups,
          data: action.response?.data,
          loading: false,
        }
      };
    case "LOAD_ENTERPRISE_GROUPS_FAILED":
      return {
        ...state,
        enterpriseGroups: {
          ...state.enterpriseGroups,
          error: action.error,
          loading: false,
        }
      };
    case "LOAD_ENTERPRISE_GROUPS_RESET":
      return {
        ...state,
        enterpriseGroups: initialState.enterpriseGroups,
      };

    
    // Asset Editor --
    // Get sudo site id (using site ref and company id)
    // case "LOAD_SUDO_SITE_ID_START":
    //   return {
    //     ...state,
    //     sudoSiteId: action.data
    //   };
    // case "LOAD_SUDO_SITE_ID_SUCCESS":
    //   return {
    //     ...state,
    //     sudoSiteId: action.response.data
    //   };
    // case "LOAD_SUDO_SITE_ID_FAILED":
    //   return {
    //     ...state,
    //     sudoSiteId: null,
    //     error: action.error,
    //   };
    // case "LOAD_SUDO_SITE_ID_RESET":
    // return {
    //   ...state,
    //   sudoSiteId: null,
    // };

    // Pin Maps
    case "LOAD_PIN_MAPS_START":
      return {
        ...state,
        loadingPinMaps: true,
      };

    case "LOAD_PIN_MAPS_SUCCESS":
      return {
        ...state,
        pinMaps: action.data,
        loadingPinMaps: false,
      }

    case "LOAD_PIN_MAPS_FAILED":
      return {
        ...state,
        loadingPinMaps: false,
      };

    case "LOAD_PIN_MAPS_CANCEL":
      return {
        ...state,
        loadingPinMaps: false,
      };
    
    case "LOAD_PIN_MAPS_RESET":
      return {
        ...state,
        pinMaps: {},
        loadingPinMaps: false,
      };

    // Load Enterprise Associations
    case "LOAD_ENTERPRISE_ASSOCIATIONS_START":
      return {
        ...state,
        loadingEnterpriseAssociations: true,
      };

    case "LOAD_ENTERPRISE_ASSOCIATIONS_SUCCESS":
      return {
        ...state,
        enterpriseAssociations: action.response.data.enterpriseAssociations,
        loadingEnterpriseAssociations: false,
      }

    case "LOAD_ENTERPRISE_ASSOCIATIONS_FAILED":
      return {
        ...state,
        loadingEnterpriseAssociations: false,
        error: action.error,
      };


    // Company assets
    case "LOAD_COMPANY_ASSETS_START":
      return {
        ...state,
        assets: {
          ...state.assets,
          company: {
            ...state.assets.company,
            loadingCompanyAssets: true,
          }
        }
      }

      case "LOAD_COMPANY_ASSETS_SUCCESS":
        const filterQueryString = action.payload?.filterData?.filterQueryString;
        const filtersActive = action.payload?.filterData?.filtersActive;
        const assetFields = action.payload?.response?.data?.asset_fields;
        const assets = action.payload?.response?.data?.assets;
        const pagination = action.payload?.response?.data?.pagination;
        return {
          ...state,
          assets: {
            ...state.assets,
            company: {
              ...state.assets.company,
              data: {
                ...state.assets.company.data,
                assetFields: assetFields,
                assets: assets,
                pagination: {
                  ...state.assets.company.data.pagination,
                  count: pagination.count,
                  pageCount: pagination.pageCount,
                  displayPageIndex: pagination.page || state.assets.company.data.pagination.displayPageIndex,
                  pageSize: pagination.perPage || 20,
                  filters: [
                    pagination.filters
                  ] || [],
                  filterQueryString: filterQueryString ?? "",
                  filtersActive: filtersActive ?? false,
                },
              },
              loadingCompanyAssets: false,
            },
          },
        };

    case "LOAD_COMPANY_ASSETS_FAILED":
      return {
          ...state,
          assets: {
            ...state.assets,
            company: {
              ...state.assets.company,
              data: {
                ...state.assets.company.data,
              },
              loadingCompanyAssets: false,
            },
          },
        };

    // Site assets
    case "LOAD_SITE_ASSETS_START":
      return {
        ...state,
        assets: {
          ...state.assets,
          site: {
            ...state.assets.site,
            loadingSiteAssets: true,
          }
        }
      }

      case "LOAD_SITE_ASSETS_SUCCESS":
        const siteAssetFields = action.data.asset_fields;
        const siteAssets = action.data.assets;
        const sitePagination = action.data.pagination;
        return {
          ...state,
          assets: {
            ...state.assets,
            site: {
              ...state.assets.site,
              data: {
                ...state.assets.site.data,
                assetFields: siteAssetFields,
                assets: siteAssets,
                pagination: {
                  ...state.assets.site.data.pagination,
                  count: sitePagination.count,
                  pageCount: sitePagination.pageCount,
                  displayPageIndex: sitePagination.page || state.assets.site.data.pagination.displayPageIndex,
                  pageSize: sitePagination.perPage || 20,
                  filters: [
                    sitePagination.filters
                  ] || [], 
                },
              },
              loadingSiteAssets: false,
            },
          },
        };

      case "LOAD_SITE_ASSETS_FAILED":
        return {
          ...state,
          assets: {
            ...state.assets,
            site: {
              ...state.assets.site,
              data: {
                ...state.assets.site.data,
              },
              loadingSiteAssets: false,
            },
          },
        };

      // Site assets
      case "LOAD_SITE_VIEW_ASSET_START":
        return {
          ...state,
          assets: {
            ...state.assets,
            site: {
              ...state.assets.site,
              loadingSiteAssets: true,
            }
          }
        }

        case "LOAD_SITE_VIEW_ASSET_SUCCESS":
          return {
            ...state,
            assets: {
              ...state.assets,
              site: {
                ...state.assets.site,
                data: {
                  ...state.assets.site.data,
                  assetFields: siteAssetFields,
                  assets: siteAssets,
                  pagination: {
                    ...state.assets.site.data.pagination,
                    count: sitePagination.count,
                    pageCount: sitePagination.pageCount,
                    displayPageIndex: sitePagination.page || state.assets.site.data.pagination.displayPageIndex,
                    pageSize: sitePagination.perPage || 20,
                    filters: [
                      sitePagination.filters
                    ] || [], 
                  },
                },
                loadingSiteAssets: false,
              },
            },
          };

        case "LOAD_SITE_VIEW_ASSET_FAILED":
          return {
            ...state,
            assets: {
              ...state.assets,
              site: {
                ...state.assets.site,
                data: {
                  ...state.assets.site.data,
                },
                loadingSiteAssets: false,
              },
            },
          };


        case "SET_ASSET_ID":
          return {
            ...state,
            assets: {
              ...state.assets,
              site: {
                ...state.assets.site,
                data: {
                  ...state.assets.site.data,
                  assetId: action.payload.assetId,
                  overrideLocal: action.payload?.overrideLocal ?? false,
                },
              },
            },
          };
        
          case "SET_SITE_ASSET_VIEW_UID":
          return {
            ...state,
            assets: {
              ...state.assets,
              siteView: {
                ...state.assets.site,
                data: {
                  ...state.assets.site.data,
                  assetUid: action.payload,
                },
              },
            },
          };
        
        case "LOAD_SITE_ASSETS_RESET":
        return {
          ...state,
          assets: {
            ...state.assets,
            site: {
              ...state.assets.site,
              data : {
                assetFields: {},
                assets: {},
                assetId: null,
                pagination: {
                  count: 0,
                  pageCount: 1,
                  pageSize: 20,
                  perPage: 20,
                  nameFilter: null,
                  sortField: null,
                  sortDirection: "desc",
                  filters: [],
                  displayPageIndex: 0,
                },
              },   
              loadingSiteAssets: false,
            },
          },
        };

    
    // Company assets - Import Logs
    case "LOAD_COMPANY_ASSET_LOGS_START":
      return {
        ...state,
        assets: {
          ...state.assets,
          companyAssetImportLogs: {
            ...state.assets.companyAssetImportLogs,
            loadingCompanyAssetLogs: true,
          }
        }
      }

      case "LOAD_COMPANY_ASSET_LOGS_SUCCESS":
        const logs = action.data?.logs;
        const logsPagination = action?.data?.pagination

        return {
          ...state,
          assets: {
            ...state.assets,
            companyAssetImportLogs: {
              ...state.assets.companyAssetImportLogs,
              data: {
                ...state.assets.companyAssetImportLogs?.data,
                logs: logs ?? [],
                pagination: {
                  ...state.assets.companyAssetImportLogs.data.pagination,
                  count: logsPagination.count ?? 0,
                  pageCount: logsPagination.pageCount ?? 1,
                  displayPageIndex: logsPagination.page || state.assets.companyAssetImportLogs.data.pagination.displayPageIndex,
                  pageSize: logsPagination.perPage || 10,
                  perPage: logsPagination.perPage || 10,
                  filters: [
                    logsPagination.filters
                  ] || [],
                  // filterQueryString: filterQueryString ?? "",
                  // filtersActive: filtersActive ?? false,
                },
              },
              loadingCompanyAssetLogs: false,
            },
          },
        };

    case "LOAD_COMPANY_ASSET_LOGS_FAILED":
      return {
          ...state,
          assets: {
            ...state.assets,
            companyAssetImportLogs: {
              ...state.assets.companyAssetImportLogs,
              data: {
                ...state.assets.companyAssetImportLogs.data,
              },
              loadingCompanyAssetLogs: false,
            },
          },
        };

    // Company assets - Inidividual Log View
    case "LOAD_COMPANY_ASSET_LOG_VIEW_START":
      return {
        ...state,
        assets: {
          ...state.assets,
          companyAssetLogView: {
            ...state.assets.companyAssetLogView,
            loadingCompanyAssetLogView: true,
            ...state.assets.companyAssetLogView.initialiseLog,
          }
        }
      }

      case "LOAD_COMPANY_ASSET_LOG_VIEW_SUCCESS":
        const logViewData = action.data?.logs;
        const logViewPagination = action?.data?.pagination

        return {
          ...state,
          assets: {
            ...state.assets,
            companyAssetLogView: {
              ...state.assets.companyAssetLogView,
              data: {
                ...state.assets.companyAssetLogView?.data,
                logViewData: logViewData ?? [],
                pagination: {
                  ...state.assets.companyAssetLogView.data.pagination,
                  count: logViewPagination.count ?? 0,
                  pageCount: logViewPagination.pageCount ?? 1,
                  displayPageIndex: logViewPagination.page || state.assets.companyAssetLogView.data.pagination.displayPageIndex,
                  pageSize: logViewPagination.perPage || logViewPagination?.limit || 10,
                  filters: [
                    logViewPagination.filters
                  ] || [],
                  // filterQueryString: filterQueryString ?? "",
                  // filtersActive: filtersActive ?? false,
                },
              },
              loadingCompanyAssetLogView: false,
              initialiseLog: false,
            },
          },
        };

    case "LOAD_COMPANY_ASSET_LOG_VIEW_FAILED":
      return {
          ...state,
          assets: {
            ...state.assets,
            companyAssetLogView: {
              ...state.assets.companyAssetLogView,
              data: {
                ...state.assets.companyAssetLogView?.data,
              },
              loadingCompanyAssetLogView: false,
              initialiseLog: false,
            },
          },
        };
    
    case "RESET_COMPANY_ASSET_LOG_VIEW":
      return {
        ...state,
        assets: {
          ...state.assets,
          companyAssetLogView: initialState?.assets.companyAssetLogView,
        }
      }
    // ------------------------------------------------------------------------

    // Company Enterprise Associations ----|>
    // ASSOCIATED Enterprises With Company ------------>
    case "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_START":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingAssociatedEnterprises: true,
        }
      }

      case "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_SUCCESS":
        const associatedPagination = action?.data?.associatedEnterprises?.pagination;

        return {
          ...state,
          manageEnterpriseAssociations: {
            ...state.manageEnterpriseAssociations,
            associated: {
              ...state.manageEnterpriseAssociations.associated,
              data: action.data?.associatedEnterprises?.data || [],
              pagination: {
                ...state.manageEnterpriseAssociations.associated.pagination,
                count: associatedPagination.count ?? 0,
                pageCount: associatedPagination.pageCount ?? 1,
                displayPageIndex: associatedPagination.page || state.manageEnterpriseAssociations.associated.pagination.displayPageIndex,
                pageSize: associatedPagination.perPage || 5,
                filters: associatedPagination.filters || state.manageEnterpriseAssociations.associated.pagination.filters || [],
              },
            },
            loadingAssociatedEnterprises: true,
          }
        };

    case "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_FAILED":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingAssociatedEnterprises: false,
        },
      }
    // ------------------------------------------------------------------------|
    // Enterprises NOT associated With Company ------------>
    case "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_START":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingUnassociatedEnterprises: true,
        }
      }

      case "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_SUCCESS":
        const unassociatedPagination = action?.data?.unassociatedEnterprises?.pagination;

        return {
          ...state,
          manageEnterpriseAssociations: {
            ...state.manageEnterpriseAssociations,
            unassociated: {
              ...state.manageEnterpriseAssociations.unassociated,
              data: action.data?.unassociatedEnterprises?.data || [],
              pagination: {
                ...state.manageEnterpriseAssociations.unassociated.pagination,
                count: unassociatedPagination.count ?? 0,
                pageCount: unassociatedPagination.pageCount ?? 1,
                displayPageIndex: unassociatedPagination.page || state.manageEnterpriseAssociations.unassociated.pagination.displayPageIndex,
                pageSize: unassociatedPagination.limit || 10,
                filters: [
                  unassociatedPagination.filters
                ] || [],
              },
            },
            loadingUnassociatedEnterprises: false,
          }
        };

    case "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_FAILED":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingUnassociatedEnterprises: false,
        },
      }
    // ------------------------------------------------------------------------|
    // Soft Deleted Enterprises Associated With Company ------------>
    case "LOAD_COMPANY_DELETED_ENTERPRISES_START":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingDeletedEnterprises: true,
        }
      }

      case "LOAD_COMPANY_DELETED_ENTERPRISES_SUCCESS":
        const deletedPagination = action?.data?.deletedEnterprises?.pagination;

        return {
          ...state,
          manageEnterpriseAssociations: {
            ...state.manageEnterpriseAssociations,
            deleted: {
              ...state.manageEnterpriseAssociations.deleted,
              data: action.data?.deletedEnterprises?.data || [],
              pagination: {
                ...state.manageEnterpriseAssociations.deleted.pagination,
                count: deletedPagination.count ?? 0,
                pageCount: deletedPagination.pageCount ?? 1,
                displayPageIndex: deletedPagination.page || state.manageEnterpriseAssociations.deleted.pagination.displayPageIndex,
                pageSize: deletedPagination.limit || 10,
                filters: [
                  deletedPagination.filters
                ] || [],
              },
            },
            loadingDeletedEnterprises: false,
          }
        };

    case "LOAD_COMPANY_DELETED_ENTERPRISES_FAILED":
      return {
        ...state,
        manageEnterpriseAssociations: {
          ...state.manageEnterpriseAssociations,
          associated: {
            ...state.manageEnterpriseAssociations.associated,
          },
          unassociated: {
            ...state.manageEnterpriseAssociations.unassociated,
          },
          deleted: {
            ...state.manageEnterpriseAssociations.deleted,
          },
          loadingDeletedEnterprises: false,
        },
      }
    // ------------------------------------------------------------------------|

    // Load Company Sites in Create Enterprise Modal ------------>
    case "LOAD_COMPANY_CREATE_ENTERPRISE_START":
      return {
        ...state,
        createEnterpriseCompanySites: {
          ...state.createEnterpriseCompanySites,
          loadingCompanyCreateEnterpriseSites: true,
        }
      }

      case "LOAD_COMPANY_CREATE_ENTERPRISE_SUCCESS":
        const createEnterpriseCompanySitesPagination = action?.data?.pagination;

        return {
          ...state,
          createEnterpriseCompanySites: {
            ...state.createEnterpriseCompanySites,

              data: {
                pagination: {
                  ...state.createEnterpriseCompanySites.pagination,
                  count: createEnterpriseCompanySitesPagination.count ?? 0,
                  pageCount: createEnterpriseCompanySitesPagination.pageCount ?? 1,
                  displayPageIndex: createEnterpriseCompanySitesPagination.page || state.createEnterpriseCompanySites.data.pagination.displayPageIndex,
                  pageSize: createEnterpriseCompanySitesPagination.limit || 10,
                  filters: [
                    createEnterpriseCompanySitesPagination.filters
                  ] || [],
                },
                sudoSites: action.data?.sudoSites || [],
              },
            loadingCompanyCreateEnterpriseSites: false,
          }
        };

    case "LOAD_COMPANY_CREATE_ENTERPRISE_FAILED":
      return {
        ...state,
        createEnterpriseCompanySites: {
          ...state.createEnterpriseCompanySites,
          loadingCompanyCreateEnterpriseSites: null,
        },
      }
    
      case "LOAD_COMPANY_CREATE_ENTERPRISE_RESET":
        return {
          ...state,
          createEnterpriseCompanySites: {
            ...state.createEnterpriseCompanySites,
            loadingCompanyCreateEnterpriseSites: null,
          },
        }
    // ------------------------------------------------------------------------|

    case "STORE_SITE_REF":
      return {
        ...state, 
        siteRef: action.siteRef,
      }
    
    // ------------------------------------------------------------------------| END
    
    default:
      return state;
  }
  
}

export default serviceDeskReducer;